'use client';

import React, { useId } from 'react';

interface CheckboxProps {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export default function Checkbox({
  checked,
  defaultChecked,
  onChange,
  disabled,
  className,
  children,
}: CheckboxProps) {
  const id = useId();

  const classes = [
    'ui-checkbox',
    checked && 'checked',
    disabled && 'disabled',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <label htmlFor={id} className={classes}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={onChange}
      />
      <span className="box" />
      {children}
    </label>
  );
}
